import { render, staticRenderFns } from "./scheduleClassesList.vue?vue&type=template&id=926e53b2&scoped=true"
import script from "./scheduleClassesList.vue?vue&type=script&lang=js"
export * from "./scheduleClassesList.vue?vue&type=script&lang=js"
import style0 from "./scheduleClassesList.vue?vue&type=style&index=0&id=926e53b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926e53b2",
  null
  
)

export default component.exports